import React, { Component } from 'react';
import { ScrollView, View } from 'react-native';
import { Calendar, LocaleConfig } from 'react-native-calendars';

import { ViewPropTypes } from 'deprecated-react-native-prop-types';
import { isEmpty as _isEmpty, isEqual as _isEqual } from 'lodash';
import PropTypes from 'prop-types';

import { VFText, Icon, Shimmer } from '@vfgroup-oneplatform/foundation/Components';
import { LightThemeColors } from '@vfgroup-oneplatform/foundation/Components/Themes';
import { DateCurrencyFromatter } from '@vfgroup-oneplatform/foundation/Utils';

import { getThemeImages } from '../../Themes';

import {
  calendarLoadingConfig,
  bottomLoadingConfig,
  shimmerPlaceholderConfig,
} from './AppointmentCalendar.LoadingConfig';
import style from './AppointmentCalendar.styles';

LocaleConfig.locales.en = {
  monthNames: [
    'January',
    'February',
    'March',
    'April',
    'May',
    'June',
    'July',
    'August',
    'September',
    'October',
    'November',
    'December',
  ],
  monthNamesShort: [
    'Jan',
    'Feb',
    'Mar',
    'Apr',
    'May',
    'Jun',
    'Jul',
    'Aug',
    'Sept',
    'Oct',
    'Nov',
    'Dec',
  ],
  dayNames: ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday'],
  dayNamesShort: ['S', 'M', 'T', 'W', 'T', 'F', 'S'],
  today: 'Today',
};
LocaleConfig.defaultLocale = 'en';
const { dateFormats, dateTransformer } = DateCurrencyFromatter.dateCurrencyFromatter;

class AppointmentCalendar extends Component {
  constructor(props) {
    super(props);
    this.state = {
      selectedDate: '',
      selectedTime: '',
    };
  }
  componentDidMount() {
    const { dates, selectedDate, selectedTime } = this.props;
    this.setState({
      selectedDate: dates
        ? selectedDate
          ? dateTransformer(selectedDate, dateFormats.calendarFormat)
          : dateTransformer(Object.keys(dates)[0], dateFormats.calendarFormat)
        : '',
      selectedTime: selectedTime ? selectedTime : '',
    });
  }
  componentDidUpdate(_, PrevState) {
    const { onDateOrTimeChange } = this.props;
    if (!_isEqual(PrevState, this.state)) {
      onDateOrTimeChange(this.state);
    }
  }
  getMarkedDates = () => {
    const {
      theme,
      calendarSelectedDayContainerStyle,
      calendarSelectedDayStyle,
      calendarTodayContainerStyle,
    } = this.props;
    const { selectedDate } = this.state;
    const todayStyle = calendarTodayContainerStyle ? calendarTodayContainerStyle : null;
    return {
      [dateTransformer(new Date(), dateFormats.calendarFormat)]: {
        customStyles: {
          container: todayStyle,
        },
      },
      [selectedDate]: {
        customStyles: {
          container: calendarSelectedDayContainerStyle,
          text: calendarSelectedDayStyle ?? style.calendarSelectedDateTextStyle(theme),
        },
      },
    };
  };
  formatDays = dates => {
    const keys = Object.keys(dates ?? {});
    const formattedData = {};
    for (let j = 0; j < keys.length; j++) {
      const key = dateTransformer(keys[j], dateFormats.calendarFormat);
      formattedData[key] = dates[keys[j]];
    }
    return formattedData;
  };
  renderTimeSlots = (dates, day, timeSlotActiveColor, theme) => {
    const formattedData = this.formatDays(dates);
    const timeSlots = formattedData[day];
    return timeSlots?.map((timeSlot, index) => (
      <View style={style.timeSlotContainerStyle} key={index}>
        <VFText
          i18nKey={timeSlot}
          style={style.timeSlotStyle(
            this.state.selectedTime === timeSlot,
            timeSlotActiveColor,
            theme,
          )}
          onPress={() => {
            this.setState({ selectedTime: timeSlot });
          }}
          suppressHighlighting={true}
        />
      </View>
    ));
  };

  render() {
    const { theme, isLoading, dates, timeSlotContainerActiveColor, withFullMonthName } = this.props;
    const Images = getThemeImages(theme.name);
    const dateFormat = withFullMonthName
      ? dateFormats.ordinalFullDayOfFullMonth
      : dateFormats.ordinalFullDayOfShortMonth;
    return (
      <ScrollView showsHorizontalScrollIndicator={false} showsVerticalScrollIndicator={false}>
        <>
          {isLoading ? (
            <View style={style.cardContentStyle}>
              <Shimmer
                config={calendarLoadingConfig}
                shimmerPlaceholderConfig={shimmerPlaceholderConfig}
              />
              <View style={style.timeSlotsContainerLoadingStyle}>
                <View style={style.timeSlotContainerLoadingStyle}>
                  <View style={style.timeSlotLoadingStyle(theme)} />
                </View>
                <View style={style.timeSlotContainerLoadingStyle}>
                  <View style={style.timeSlotLoadingStyle(theme)} />
                </View>
                <View style={style.timeSlotContainerLoadingStyle}>
                  <View style={style.timeSlotLoadingStyle(theme)} />
                </View>
                <View style={style.timeSlotContainerLoadingStyle}>
                  <View style={style.timeSlotLoadingStyle(theme)} />
                </View>
                <View style={style.timeSlotContainerLoadingStyle}>
                  <View style={style.timeSlotLoadingStyle(theme)} />
                </View>
              </View>
              <Shimmer
                config={bottomLoadingConfig}
                shimmerPlaceholderConfig={shimmerPlaceholderConfig}
              />
            </View>
          ) : (
            <View style={style.cardContentStyle}>
              <Calendar
                style={style.calendarStyle}
                theme={{
                  calendarBackground: theme.colors.cardBackgroundColor,
                  ...style.monthTitleStyle(theme, withFullMonthName),
                  ...style.dayNamesStyles(theme),
                  textDisabledColor: style.disabledDaysNumbersStyles.color,
                }}
                minDate={dateTransformer(new Date(), dateFormats.calendarFormat)}
                maxDate={
                  dates
                    ? dateTransformer(
                        Object.keys(dates)[Object.keys(dates).length - 1],
                        dateFormats.calendarFormat,
                      )
                    : null
                }
                onDayPress={day => {
                  this.setState({
                    selectedDate: day.dateString,
                    selectedTime: '',
                  });
                }}
                monthFormat={withFullMonthName ? 'MMMM yyyy' : 'MMM yyyy'}
                hideExtraDays={true}
                firstDay={1}
                disableAllTouchEventsForDisabledDays={true}
                markingType={'custom'}
                markedDates={this.getMarkedDates()}
                renderArrow={direction => (
                  <Icon
                    name={
                      direction === 'right'
                        ? Images.ic_chevron_right_black_white
                        : Images.ic_chevron_left_black_white
                    }
                    type="image"
                    style={style.calendarArrowStyle(direction)}
                  />
                )}
              />
              <VFText
                i18nKey={'book_appointment_date_available_slots'}
                style={style.textStyle(theme)}
              />
              <VFText
                i18nKey={
                  _isEmpty(this.state.selectedDate)
                    ? ''
                    : dateTransformer(this.state.selectedDate, dateFormat)
                }
                style={style.selectedDateTextStyle(theme)}
              />
              <View style={style.timeSlotsContainerStyle}>
                {this.renderTimeSlots(
                  dates,
                  this.state.selectedDate,
                  timeSlotContainerActiveColor,
                  theme,
                )}
              </View>
            </View>
          )}
        </>
      </ScrollView>
    );
  }
}

AppointmentCalendar.defaultProps = {
  theme: LightThemeColors,
  onDateOrTimeChange: () => {},
  calendarSelectedDayContainerStyle: {},
  calendarTodayContainerStyle: {},
  withFullMonthName: true,
};

AppointmentCalendar.propTypes = {
  theme: PropTypes.object,
  isLoading: PropTypes.bool,
  dates: PropTypes.object,
  onDateOrTimeChange: PropTypes.func,
  selectedDate: PropTypes.string,
  selectedTime: PropTypes.string,
  calendarSelectedDayContainerStyle: ViewPropTypes.style,
  calendarSelectedDayStyle: ViewPropTypes.style,
  calendarTodayContainerStyle: ViewPropTypes.style,
  timeSlotContainerActiveColor: PropTypes.string,
  withFullMonthName: PropTypes.bool,
};

export default AppointmentCalendar;
